export default __webpack_public_path__ + "static/media/4.aa2f624b.svg";